import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7e893866"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewDetails" }

import { useRouter } from "vue-router";
import { setField } from "@/utiles/utiles";
import { ref, reactive, onMounted, toRaw, watch } from "vue";
import TargetInfo from "./components/TargetInfo.vue";
import SimilarTarget from "./components/SimilarTarget.vue";
import PayTarget from "./components/PayTarget.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'viewDetails',
  props: ['form', 'id','targetInfo','targetType'],
  emits: ['isShowSure', 'setForm'],
  setup(__props, { emit }) {

const { form, id ,targetInfo,targetType} = __props;




const Router = useRouter();
const cosUrl = targetInfo.cosUrl;
const ossUrl = targetInfo.ossUrl;

watch(form, (newVal,oldVal) => {
  console.log('newVal,oldVal', newVal,oldVal)
},{immediate:true,deep:true})

onMounted(() => {
  console.log("ossUrl,cosUrl", cosUrl, ossUrl)
});

const goBack = () => {
  Router.back();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(TargetInfo, {
      targetInfo: __props.targetInfo.targetInfo,
      ossUrl: _unref(ossUrl),
      cosUrl: _unref(cosUrl),
      type: true,
      farmerInfo: __props.targetInfo.farmerInfo
    }, null, 8, ["targetInfo", "ossUrl", "cosUrl", "farmerInfo"]),
    _createVNode(SimilarTarget, {
      form: __props.form,
      targetInfo: __props.targetInfo,
      targetType: __props.targetType,
      ossUrl: _unref(ossUrl),
      cosUrl: _unref(cosUrl)
    }, null, 8, ["form", "targetInfo", "targetType", "ossUrl", "cosUrl"]),
    _createVNode(PayTarget, {
      form: __props.form,
      targetInfo: __props.targetInfo,
      targetType: __props.targetType,
      ossUrl: _unref(ossUrl),
      cosUrl: _unref(cosUrl)
    }, null, 8, ["form", "targetInfo", "targetType", "ossUrl", "cosUrl"])
  ]))
}
}

})